<ul class="list-none p-0 m-0">
  <li *ngFor="let item of noteRework" class="py-3 border-bottom-1 surface-border">
    <div class="line-height-3 text-700" style="max-width: 30rem">{{ item.nota }}</div>
  </li>
</ul>
<div class="d-flex justify-content-center border-top-1 surface-border pt-3" style=" display: flex;">
  <button pButton pRipple icon="pi pi-check" (click)="this.dialogRef.close({ success: true });" label="Chiudi"></button>
</div>
 
